//@ts-ignore
import BaseModel from './BaseModel';
// @ts-ignore
import crApi from '../service/CrApi';
// @ts-ignore
import SecurityService from "../service/SecurityService";

class MessageModel extends BaseModel {
    public async get(params: Record<string, any> = {}) {
        params['website_token'] = SecurityService.getToken();
        const result = await crApi.requestV2('message/retrieve/', params);
        result.message = await crApi.extractCollection(result.message);
        return result;
    };

    public async update(params = {}) {
        return await crApi.requestV2('message', 'update', params);
    };

    public async getById(id, messageParams = {}) {
        const params: Record<string, any> = {
            'website_token': SecurityService.getToken()
        };

        // Determine if id is numeric or text
        const code = +id;
        if (isNaN(code)) {
            params['textId'] = id;
        } else {
            params['messageId'] = id;
        }

        // Process message parameters
        const alterParams: Record<string, any> = {};
        alterParams[id] = [];

        if (Array.isArray(messageParams)) {
            alterParams[id] = [...messageParams];
        }

        params['alterParams'] = alterParams;

        // Get and process result
        const result = await this.get(params);
        if (result.count === 0) {
            return '';
        }

        return result.message[0];
    };
}

export default new MessageModel();
